module.exports = __webpack_public_path__ + "/c20e9fe8a0ac25c226af77d666908f2e.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/assets/onedrive_logo_white.svg
 ** module id = 1260
 ** module chunks = 0
 **/